import { createCommand, Option } from '@commander-js/extra-typings';
import { NO_TTY_JSON_OUTPUT_OPTION } from '@wix/cli-command-contract';
import type { AstroCommandServices } from '@wix/cli-command-contract';
import { validateGenerateSchemaExtensionType } from './validations.js';
import { runCommand } from './render-command.js';

export const schemaGenerateExtensionsCommand = (
  services: AstroCommandServices,
  cliVersion: string
) =>
  createCommand('generate')
    .description(
      'Print a JSON schema of all available extension types and their required inputs'
    )
    .addOption(
      new Option(
        '--type <type>',
        'Print the schema for a single extension type instead of the full schema'
      ).argParser(validateGenerateSchemaExtensionType)
    )
    .addOption(
      new Option(NO_TTY_JSON_OUTPUT_OPTION, 'Output in JSON format')
        .default(true)
        .hideHelp()
    )
    .action(async (opts, command) => {
      await runCommand(command, services, cliVersion, async (model) => {
        const { nonInteractiveSchemaGenerateExtensions } = await import(
          '../non-interactive/schema-generate-extensions.js'
        );
        return nonInteractiveSchemaGenerateExtensions(services, model, {
          type: opts.type,
        });
      });
    });
